<template>
  <header class="header"
          ref="headerleads">

    <div class="filters">
      <app-date-range-filter data-entity="leads" />

      <local-estableshiment-filter v-if="!isAdmin" data-entity="leads" />

      <usage-terms-filter v-if="!isAdmin"
                          data-entity="leads" />

      <button class="btn btn-extra-round btn-primary"
              @click="emitLoadData">{{$t('message.generics.message.fetchData')}}</button>

      <div class="search-wrapper">
        <app-search @input="search"
                    @enter="emitLoadData" />
      </div>
    </div>

    <i class="mdi mdi-file-download-outline mr-4"
       v-tooltip.auto="$t('message.generics.message.exportCsv')"
       @click="download"></i>    

    <i class="mdi mdi-view-list"       
       v-tooltip.auto="$t('message.leads.message.manageTableFields')"
       @click="openLeadsAccessCustomizationModal"></i>

    <leads-access-customization-modal v-model="showingLeadsAccessCustomizationModal"
                                      :list="extraFields"/>   

  </header>
</template>

<script>
import UsageTermsFilter from "@components/filters/UsageTermsFilter";
import LocalEstableshimentFilter from "@components/filters/LocalEstableshimentFilter";
import EventBus from "@packages/event-bus";
import AppDateRangeFilter from "@components/filters/DateRangeFilter";
import AppSearch from "@components/Search";
import LeadsAccessCustomizationModal from "../customization/modal/LeadsAccessCustomizationModal.vue";

export default {
  components: {
    AppDateRangeFilter,
    AppSearch,
    UsageTermsFilter,
    LocalEstableshimentFilter,
    LeadsAccessCustomizationModal
  },

  data() {
    return {
      showingLeadsAccessCustomizationModal: false,
      extraFields: []
    }
  },

  computed: {
    view: {
      get() {
        return this.$store.state.leads.view;
      },

      set(value) {
        this.$store.commit("LEADS_SET_VIEW", value);
      },
    },

    user() {
      return this.$store.state.users.user;
    },

    filters() {
      return this.$store.state.leads.filters;
    },

    isAnunciante() {
      return this.$store.state.users.user.tipo === "ANUNCIANTE";
    },

    isEstabelecimento() {
      return this.$store.state.users.user.tipo === "ESTABELECIMENTO";
    },

    permissions() {
      return this.$store.state.users.user.permissions;
    },

    hasEstableshimentFilter() {
      return !!this.filters.establishments.length;
    },

    estableshimentFilter() {
      return this.filters.establishments;
    },

    isAdmin() {
      return this.$store.state.users.admin && !this.$store.state.users.user;
    },
  },

  mounted() {
    this.$store.commit("LEADS_RESET_FILTER");
    let width = this.$refs.headerleads.clientWidth;
    let colsPerPage = Math.floor(width / 360);
    this.$store.commit("LEADS_SET_COLS_PER_PAGE", colsPerPage);
  },

  async created() {
        await this.loadExtraFields()
  },

  methods: {
    openLeadsAccessCustomizationModal() {
      this.showingLeadsAccessCustomizationModal = true;
    },
    async download() {
      EventBus.$emit("SHOW_SPINNER");

      const csv = await this.fetchCsv();

      const link = this.createElement(csv);

      link.click();

      EventBus.$emit("CANCEL_SPINNER");
    },

    async fetchCsv() {
      return this.$loader.leads.csv({ filters: this.filters });
    },

    createElement(csv) {
      const url = window.URL.createObjectURL(new Blob([csv]));
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", "leads.csv");
      document.body.appendChild(link);

      return link;
    },

    search(search) {
      this.$store.commit("LEADS_SET_FILTER", { key: "search", value: search });
    },

    emitLoadData() {
      EventBus.$emit("LOAD_DATA");
    },

    async loadExtraFields() {
      try {
          this.extraFieldsLoaded = false;

          const list = await this.$api.core.extraField.extraFieldsList();

          list.map(item => item.showing = false)

          this.extraFields = list;

          this.extraFieldsLoaded = true;
      } catch (error) {
          console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .filters {
    display: flex;
    align-items: center;
    justify-content: space-around;

    flex-grow: 1;

    .search-wrapper {
      max-width: 200px;
    }
  }

  .mdi {
    font-size: 28px;
    color: $grey-6;
    cursor: pointer;

    &.active {
      color: $blue-primary;
    }

    &.mdi-view-grid {
      font-size: 22px;
    }
  }
}
</style>
